export default __webpack_public_path__ + "static/logo-website-28d55908917b0370094a5479e16716b3.svg";